import { User } from '@deltek/specification-client/core/Models/user'
import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

export interface ChatProfileState {
    /**
     * The user associated with the chat messages.
     */
    chatUser?: Partial<User>

    /**
     * Sets the user associated with the chat messages.
     * @param user - The user to set. If not provided, the chat user will be cleared.
     */
    setChatUser: (user?: Partial<User>) => void
}

export const useChatProfileStore = create<ChatProfileState>()((set) => ({
    setChatUser: (user?: Partial<User>) => {
        set((state) => ({
            chatUser: user,
        }))
    },
}))

/**
 * A custom hook that retrieves a shallowly selected value from the `useChatProfileStore` store.
 *
 * Sample usage:
 * ```typescript
 * const { chatUser } = useChatProfileShallowSelector((state) => ({
 *   chatUser: state.chatUser,
 * }));
 * ```
 *
 * @param selector - A function that takes the store state and returns the value to be selected.
 * @returns The selected value from the store.
 */
export const useChatProfileShallowSelector = <T>(
    selector: (state: ChatProfileState) => T
): T => useChatProfileStore(useShallow(selector))
